export const searchIdentifierCopy = {
  ru: { numberHint: 'Номер или начало номера', binHint: 'БИН или первые цифры' },
  kk: { numberHint: 'Нөмір немесе оның басы', binHint: 'БСН немесе алғашқы цифрлар' },
};
